import { Field, ErrorMessage } from 'formik';
import { FieldEntityProps, SmsCheckBoxClassNamesInterface } from '../types';
import { getSmsOptInValues } from '../utils';

interface AccessibleSmsCheckboxProps {
  field: FieldEntityProps | undefined;
  smsCheckBoxFieldClassNames: SmsCheckBoxClassNamesInterface;
  isTouchedAndError: boolean;
  showErrorMessages?: boolean;
}

const AccessibleSmsCheckbox = ({
  field,
  smsCheckBoxFieldClassNames,
  isTouchedAndError,
  showErrorMessages = false,
}: AccessibleSmsCheckboxProps) => {
  const name = field?.parameterName || 'sms_opt_in';
  const { smsText, smsCtaText, smsCtaHref } = getSmsOptInValues(
    field ? [field] : [],
  );
  const errorId = `${name}-error`;

  return (
    <div className={smsCheckBoxFieldClassNames.container}>
      <Field
        type="checkbox"
        name={name}
        id={name}
        className={smsCheckBoxFieldClassNames.mainField}
        aria-describedby={
          showErrorMessages && isTouchedAndError ? errorId : undefined
        }
        aria-invalid={isTouchedAndError}
      />
      <div className={smsCheckBoxFieldClassNames.textAndErrorContainer}>
        <label
          htmlFor={name}
          className={smsCheckBoxFieldClassNames.disclaimerTextClassName}
        >
          {smsText?.value}{' '}
          <a href={smsCtaHref} target="_blank" rel="noopener noreferrer">
            {smsCtaText?.value}
          </a>
        </label>
        {showErrorMessages && isTouchedAndError && (
          <div
            id={errorId}
            role="alert"
            className={smsCheckBoxFieldClassNames.error}
          >
            <ErrorMessage name={name} />
          </div>
        )}
      </div>
    </div>
  );
};

export default AccessibleSmsCheckbox;
